import { render, staticRenderFns } from "./Icon.htm?vue&type=template&id=4f50b036&scoped=true&"
import script from "./Icon.js?vue&type=script&lang=js&"
export * from "./Icon.js?vue&type=script&lang=js&"
import style0 from "./Icon.scss?vue&type=style&index=0&id=4f50b036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f50b036",
  null
  
)

export default component.exports